import { render, staticRenderFns } from "./riskVariable.vue?vue&type=template&id=022146ad&scoped=true"
import script from "./riskVariable.vue?vue&type=script&lang=js"
export * from "./riskVariable.vue?vue&type=script&lang=js"
import style0 from "./riskVariable.vue?vue&type=style&index=0&id=022146ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022146ad",
  null
  
)

export default component.exports